import React from "react";
import { ForgotPasswordsendotpApi } from "../../apis";
import toast from "react-hot-toast";
import { EditProfileLoader } from "../../components/common/loader";
import OtpInput from "react-otp-input";
import Countdown from "../../components/Countdown/Countdown";
import FPHeader from "./FPHeader";
import { commonUsedClass } from "../Account/MobileLoginTalwind";

export default function FPPage_2({ formik, email, handleOtpInput, loader, setLoader, isWrongOtp, otp, BacktoSignin }) {

    const resendOtp = async () => {
        try {
            // setLoader(true)
            const payload = {
                email: email,
            };
            const response = await ForgotPasswordsendotpApi(payload);
            if (response.status === 200) {
                toast.success(response.data.message);
            }
        } catch (error) {
            const message =
                error?.response?.data?.message || error?.response?.statusText;
            toast.error(message, { id: 'error' });
        }
        finally {
            //setLoader(false)
        }
    };

    return (
        <div>
            <FPHeader
                Title={'Enter verification code'}
                TitleDescription={'Enter the 4 digits code that you received on your email.'}
                BacktoSignin={() => { BacktoSignin() }}
            />
            <form className="verifyotp" onSubmit={formik.handleSubmit} >
                <div className="my-2 py-2 flex items-center justify-center" >
                    <OtpInput
                        inputStyle={
                            {
                                marginLeft: '0',
                                width: '3.375rem',
                                height: '3.375rem',
                                borderRadius: '0.375rem',
                                textAlign: 'center',
                                border: '1px solid rgba(111, 117, 135, 0.16)',
                            }
                        }
                        className={'me-2 text-center fs-3  w-50 otpInputt'}
                        errorStyle={{ border: 'solid 1px red' }}
                        hasErrored={isWrongOtp}
                        isInputNum
                        value={otp}
                        onChange={(otp) => handleOtpInput(otp)}
                        numInputs={4}
                        separator={< span className="w-6" > </span>}
                    />
                </div>
                < div className="modelFooter" >

                    < p >
                        <Countdown initialSeconds={60} resendOtp={resendOtp} />
                    </p>
                    < div className="mt-6" >
                        <button
                            className={commonUsedClass.btncon}
                            type="submit"
                        >
                            {!loader ? (
                                'Continue'
                            ) : (
                                <div className="text-xs" >
                                    <EditProfileLoader />
                                </div>
                            )}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    )
}